export const GET_USER_GRAPH = "[USER_GRAPH] GET_USER_GRAPH";
export const GET_USER_GRAPH_SUCCESS = "[USER_GRAPH] GET_USER_GRAPH_SUCCESS";
export const GET_USER_GRAPH_FAILED = "[USER_GRAPH] GET_USER_GRAPH_FAILED";

export const GET_USER_ACTIVE_GRAPH = "[USER_GRAPH] GET_USER_ACTIVE_GRAPH";
export const GET_USER_ACTIVE_GRAPH_SUCCESS = "[USER_GRAPH] GET_USER_ACTIVE_GRAPH_SUCCESS";
export const GET_USER_ACTIVE_GRAPH_FAILED = "[USER_GRAPH] GET_USER_ACTIVE_GRAPH_FAILED";
